import * as React from 'react';
import { parseBoolean } from '../../utils/parse';
import { Badge } from 'primereact/badge';

export default function BooleanBadge({ value }: { value: unknown }) {
  const boolValueAsString = parseBoolean(value);
  const badgeSeverity = React.useMemo(() => {
    return boolValueAsString === 'Yes' ? 'success' : 'danger';
  }, [value]);


  return (
    <Badge severity={badgeSeverity} value={boolValueAsString} />
  )
}